<ng-container [ngTemplateOutlet]="carrouselItem.isAddMember ? addMember : otherContracts"> </ng-container>

<ng-template #addMember>
  <a class="btn carrousel-avatar-button" [href]="carrouselItem.button.link | link">
    <span class="carrousel-avatar-image-border carrousel-avatar-border">
      <img class="carrousel-avatar-image" alt="{{ carrouselItem.avatarAlt }}" [src]="carrouselItem.avatarSrc" />
    </span>
    <span class="justify-content-center pt-1">
      <h3 class="carrousel-avatar-label standard mb-0">
        {{ carrouselItem.button.label }}
      </h3>
    </span>
  </a>
</ng-template>

<ng-template #otherContracts>
  <div class="btn carrousel-avatar-button" [class.carrousel-avatar-selected]="carrouselItem.isSelected">
    <span class="carrousel-avatar-image-border carrousel-avatar-border">
      <img class="carrousel-avatar-image" alt="{{ carrouselItem.avatarAlt }}" [src]="carrouselItem.avatarSrc" />
    </span>

    <span class="justify-content-center px-1 py-1">
      <h3 class="carrousel-avatar-label standard mb-0" aria-description=", vos/votre offres">
        {{ carrouselItem.button.label }}
      </h3>
    </span>
  </div>
</ng-template>
